import React, { useEffect, useState } from "react";
import {
  useTheme,
  Box,
  Button,
  Skeleton,
  Typography
} from "@mui/material";
import { tokens } from "../theme";
import axios from "axios";
import Header from "../Components/Header";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import useMediaQuery from "@mui/material/useMediaQuery";
import baseURL from "../config";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { getDecryptedToken } from "../auth";

const getBannerImageSrc = (image) => {
  if (!image) return "";
  if (image.startsWith("data:image") || image.startsWith("http")) return image;
  return `data:image/png;base64,${image}`;
};

const Banners = () => 
{ 
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
  
    const isNonMobile = useMediaQuery("(min-width:620px)");
    const [isLoading, setIsLoading] = useState(true);
    const [deletingBannerId, setDeletingBannerId] = useState(null);
    

    const [bannerData, setBannerData] = useState([{
       bannerId: 0,
       image: "",
    }]);

    const token = getDecryptedToken();

    const fetchBanners = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/Banner/GetAllBanners`);

        if (response.data.success === true) {
          setBannerData(response.data.banners || []);
        } else {
          toast.error(response.data.message || "Failed to fetch banners");
        }
      } catch (error) {
        toast.error(`Error: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    };

    useEffect(() => {
      fetchBanners();
    }, []);

    const handleDeleteBanner = async (bannerId) => {
      const shouldDelete = window.confirm(`Delete banner #${bannerId}?`);
      if (!shouldDelete) return;

      setDeletingBannerId(bannerId);
      try {
        await axios.delete(`${baseURL}/api/Banner/DeleteBanner`, {
          params: { id: bannerId },
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        setBannerData((banners) => banners.filter((banner) => banner.bannerId !== bannerId));
        toast.success("Banner u fshi me sukses!");
      } catch (error) {
        toast.error(error.response?.data?.message || "Banner nuk u fshi!");
      } finally {
        setDeletingBannerId(null);
      }
    };


      return (
        <Box m="10px">
          <Header title="Banners" subtitle="Detajet e Banners" />
          <ToastContainer />
          <Box mb={2} display="flex" justifyContent="flex-start">
            
          <Link to="/bannerform" style={{ textDecoration: "none" }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: colors.primary[700], marginLeft: "20px", marginTop: "8px"}}
            >
              Shto Banner
            </Button>
          </Link>
          </Box>
            
          <Box
            m="10px 0 0 0"
            sx={{
              display: "grid",
              gridTemplateColumns: isNonMobile ? "repeat(auto-fill, minmax(360px, 1fr))" : "1fr",
              gap: "18px",
            }}
          >
          {isLoading ? (
             
             <Skeleton
               variant="rectangular"
               width="100%"
               height={220}
               animation="wave"
               sx={{ gridColumn: "1 / -1", borderRadius: "8px" }}
             />
           ) : bannerData.length === 0 ? (
            <Box
              sx={{
                gridColumn: "1 / -1",
                border: `1px solid ${colors.primary[500]}`,
                borderRadius: "8px",
                padding: "32px",
                textAlign: "center",
                backgroundColor: colors.primary[500],
              }}
            >
              <Typography>No banners found.</Typography>
            </Box>
           ) : (
            bannerData.map((banner) => {
              const imageSrc = getBannerImageSrc(banner.image);

              return (
                <Box
                  key={banner.bannerId}
                  sx={{
                    border: `1px solid ${colors.primary[500]}`,
                    borderRadius: "8px",
                    overflow: "hidden",
                    backgroundColor: colors.primary[500],
                    boxShadow: "0 10px 24px rgba(0, 0, 0, 0.18)",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      aspectRatio: "771 / 170",
                      backgroundColor: colors.primary[700],
                    }}
                  >
                    {imageSrc ? (
                      <Box
                        component="img"
                        src={imageSrc}
                        alt={`Banner ${banner.bannerId}`}
                        sx={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    ) : (
                      <Box
                        sx={{
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography color="text.secondary">No image</Typography>
                      </Box>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 14px",
                    }}
                  >
                    <Typography fontWeight="700">Banner #{banner.bannerId}</Typography>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      startIcon={<DeleteOutlineOutlinedIcon />}
                      disabled={deletingBannerId === banner.bannerId}
                      onClick={() => handleDeleteBanner(banner.bannerId)}
                    >
                      Delete
                    </Button>
                  </Box>
                </Box>
              );
            })
           )}
          </Box>
        </Box>
      );
 }



 export default Banners;
